import type { CustomItemsInsightsReportDto } from './CustomItemsInsightsReportDto';
import type { CustomItemsInsightsReport } from 'model/CustomItemsInsightsReport';

const n = (v: any) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const convertToCustomItemsInsightsReport = (dto: CustomItemsInsightsReportDto): CustomItemsInsightsReport => ({
    range: {
        start: dto?.range?.start ?? '',
        end: dto?.range?.end ?? ''
    },
    totals: {
        quantity: n(dto?.totals?.quantity),
        grossSales: n(dto?.totals?.gross_sales),
        discounts: n(dto?.totals?.discounts),
        refunds: n(dto?.totals?.refunds),
        netSales: n(dto?.totals?.net_sales),
        allNetSales: n(dto?.totals?.all_net_sales)
    },
    meta: {
        page: n(dto?.meta?.page) || 1,
        perPage: n(dto?.meta?.per_page) || 10,
        totalCount: n(dto?.meta?.total_count),
        totalPages: n(dto?.meta?.total_pages) || 1
    },
    customItems: (dto?.custom_items ?? []).map(item => ({
        customItemKey: String(item?.custom_item_key ?? ''),
        customItemName: item?.custom_item_name ?? '—',
        category: item?.category ?? 'Custom Item',
        quantity: n(item?.quantity),
        avgPrice: n(item?.avg_price),
        grossSales: n(item?.gross_sales),
        discounts: n(item?.discounts),
        refunds: n(item?.refunds),
        netSales: n(item?.net_sales),
        netCustomItemsSalesPct: n(item?.net_custom_items_sales_pct),
        allNetSalesPct: n(item?.all_net_sales_pct)
    }))
});
